//Icons
import Bubble2Icon from '~icons/Bubble2Icon';
import Bubble3Icon from '~icons/Bubble3Icon';
import BubbleBottomIcon from '~icons/BubbleBottomIcon';
import BubbleIcon from '~icons/BubbleIcon';
import BubbleRevertedIcon from '~icons/BubbleRevertedIcon';



export enum BubblesType {
    SIMPLE = 'SIMPLE',
    ADVANCED = 'ADVANCED',
    ADDITIONAL = 'ADDITIONAL'
}

interface IBubbles {
    type: BubblesType
}

export default function Bubbles({type} : IBubbles) {
    return (
        <div className={`bubbles bubbles--type-${type.toLowerCase()}`}>
            <div className="bubbles__top-right">
                {type === BubblesType.SIMPLE && <BubbleIcon/>}
                {type === BubblesType.ADVANCED && <Bubble2Icon/>}
                {type === BubblesType.ADDITIONAL && <Bubble3Icon/>}
            </div>

            <div className="bubbles__bottom-left">
                {type === BubblesType.SIMPLE && <BubbleRevertedIcon/>}
                {type === BubblesType.ADVANCED && <Bubble2Icon/>}
                {type === BubblesType.ADDITIONAL && <BubbleBottomIcon/>}
            </div>
        </div>
    );
}
